import { NodoDto } from "@/api";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

export type GFL_DFA_3500_InfoProps = {
  nodo: NodoDto;
};

export function GFL_DFA_3500_Info({ nodo }: GFL_DFA_3500_InfoProps) {
  const { t } = useTranslation();
  const modelloObj = nodo.dispositivoModello;

  if (!modelloObj) {
    return null;
  }

  const info = nodo.dispositivoLastInfo;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Conta ore generale */}
      <Box>
        <Typography variant="caption">{t("gflDfa3500Info.contaOre")}</Typography>
        <Typography variant="h4">{info?.contaore ?? t("valori.nd")}</Typography>
      </Box>

      {/* Ore filtraggio - Parziale e Totale sulla stessa riga */}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box>
            <Typography variant="caption">
              {t("gflDfa3500Info.oreParzialeFiltraggio")}
            </Typography>
            <Typography variant="h4">
              {info?.["filt-ore"] ?? t("valori.nd")}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box>
            <Typography variant="caption">
              {t("gflDfa3500Info.oreTotaleFiltraggio")}
            </Typography>
            <Typography variant="h4">
              {info?.["filt-oretot"] ?? t("valori.nd")}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Ore disoleatore - Parziale e Totale sulla stessa riga */}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box>
            <Typography variant="caption">
              {t("gflDfa3500Info.oreParzialeDisoleatore")}
            </Typography>
            <Typography variant="h4">
              {info?.["diso-ore"] ?? t("valori.nd")}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box>
            <Typography variant="caption">
              {t("gflDfa3500Info.oreTotaleDisoleatore")}
            </Typography>
            <Typography variant="h4">
              {info?.["diso-oretot"] ?? t("valori.nd")}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
